<div [style.background-color]="infinity ? 'black' : null">
  <div class="container" style="margin-top: 28px;" [style.background-color]="infinity ? 'black' : null">
    <footer class="text-center" style="font-size: 12px;" [style.background-color]="infinity ? 'black' : null"
      [style.color]="infinity ? 'white' : null">
      &copy; Todos os direitos reservados a <a href="https://empreenderdinheiro.com.br/"> Empreender Dinheiro</a>
    </footer>
  </div>
</div>
